import {
  acknowledgeStoreAction,
  affirmStoreAction,
  agreeMoveToAwardedRPStoreAction,
  awardMultiStoreAction,
  awardStoreAction,
  cancelInOMSStoreAction,
  executeTradeStoreAction,
  moveStatusBackOPStoreAction,
  moveStatusBackRPStoreAction,
  moveToAwardedOPStoreAction,
  notDealtStoreAction,
  offQuoteStoreAction,
  pullRequestStoreAction,
  quoteTradeStoreAction,
  recallStoreAction,
  recreateBlocksStoreAction,
  rejectStoreAction,
  reQuoteStoreAction,
  reSendStoreAction,
  sendToPannelStoreAction,
  setToNewStoreAction,
  unawardStoreAction,
} from "@/store/tradeDataStoreACTIONS";
import {
  editFilledStoreAction,
  noMoreFillsStoreAction,
  updateFillsStoreAction,
  workingStoreAction,
} from "@/store/tradeDataStoreOrderSpecificACTIONS";
export interface IActionObj {
  id: string;
  function: Function;
  functionMulti: Function;
}

// Helper function to reverse-map the string value back to the corresponding enum key.
// export const ExecutionRequestStatusReversed: Record<string, keyof typeof ExecutionRequestStatus> = Object.keys(
export function getEnumKeyByEnumValue(myEnum: any, enumValue: any) {
  const keys = Object.keys(myEnum).filter((x) => myEnum[x] == enumValue);
  return keys.length > 0 ? keys[0] : null;
}

//first object in array is primary button and will be styled in
export const actionsConfigOP: any = {
  NotSent: {
    New: [{ id: "Send To Panel", function: sendToPannelStoreAction }],
    SelectPanel: [{ id: "Send To Panel", function: sendToPannelStoreAction }],
    NotDealt: [
      {
        id: "Set to New",
        function: setToNewStoreAction,
      },
      { id: "Cancel in OMS", function: cancelInOMSStoreAction },
      { id: "Re-create Blocks", function: recreateBlocksStoreAction },
    ],
  },
  RFQ: {
    Sent: [
      { id: "Recall All", function: recallStoreAction },
      { id: "Not Dealt All", function: notDealtStoreAction },
      // { id: "Close Trade", function: closeStoreAction },
    ],
    // Working: [
    //   { id: "Recall All", function: recallStoreAction },
    //   // { id: "Pull Order", function: pullOrderAction },
    //   // { id: "Update Level", function: updateLevelAction },
    //   // { id: "Copy Trade", function: copyTradeAction },
    // ],
    // PartiallyFilled: [
    //   // { id: "Update Level", function: updateLevelAction },
    //   // { id: "Pull Order", function: pullOrderAction },
    //   { id: "Recall Trade", function: recallStoreAction },
    //   // { id: "Copy Trade", function: copyTradeAction },
    // ],
    // // LevelUpdated: [
    // //   { id: "Update Level", function: updateLevelAction },
    // //   { id: "Pull Order", function: pullOrderAction },
    // // ],
    // LevelUpdatedCP: [
    //   // { id: "Update Level", function: updateLevelAction },
    //   { id: "Accept Level", function: acceptLevelStoreAction },
    //   // { id: "Pull Order", function: pullOrderAction },
    // ],
    ReSent: [
      { id: "Recall All", function: recallStoreAction },
      { id: "Not Dealt All", function: notDealtStoreAction },
    ],
    Acknowledged: [
      { id: "Recall All", function: recallStoreAction },
      { id: "Not Dealt All", function: notDealtStoreAction },
    ],

    Recalled: [
      { id: "Re-Send All", function: reSendStoreAction },
      { id: "Not Dealt All", function: notDealtStoreAction },
      // { id: "Close Trade", function: closeStoreAction },
    ],

    // ReOpened: [
    //   { id: "Re-Send All", function: reSendStoreAction },
    //   { id: "Not Dealt All", function: notDealtStoreAction },

    //   // { id: "Close Trade", function: closeStoreAction },
    // ],
    Rejected: [
      { id: "Re-Send All", function: reSendStoreAction },
      { id: "Not Dealt All", function: notDealtStoreAction },
      // { id: "Close Trade", function: closeStoreAction },
    ],
    Quoted: [
      {
        id: "Award to Best",
        function: awardStoreAction,
        functionMulti: awardMultiStoreAction,
      },
      { id: "Recall All", function: recallStoreAction },
      { id: "Request Requote All", function: reQuoteStoreAction },
      { id: "Not Dealt All", function: notDealtStoreAction },
    ],
    OffQuote: [
      { id: "Request Requote All", function: reQuoteStoreAction },
      { id: "Recall All", function: recallStoreAction },
      { id: "Not Dealt All", function: notDealtStoreAction },
      // { id: "Work Order", function: workOrderAction },
    ],
    // QuoteExpired: [
    //   { id: "Request Requote All", function: reQuoteStoreAction },
    //   { id: "Recall All", function: recallStoreAction },
    //   { id: "Not Dealt All", function: notDealtStoreAction },
    // ],
    ReQuoteRequested: [
      { id: "Recall All", function: recallStoreAction },
      {
        id: "Award to Best",
        function: awardStoreAction,
        functionMulti: awardMultiStoreAction,
      },
      // { id: "Request Requote All", function: reQuoteStoreAction },
      { id: "Not Dealt All", function: notDealtStoreAction },
    ],
    NotDealt: [
      { id: "Re-Send All", function: reSendStoreAction },
      { id: "Cancel in OMS", function: cancelInOMSStoreAction },
      { id: "Re-create Blocks", function: recreateBlocksStoreAction },
      // { id: "Work Order", function: workOrderAction },
    ],
    // OrderPulled: [
    //   // { id: "Close Trade", function: closeStoreAction },
    //   // { id: "Work Order", function: workOrderAction },
    //   { id: "Not Dealt All", function: notDealtStoreAction },
    // ],
    // LevelAccepted: [
    //   { id: "Update Level", function: updateLevelAction },
    //   { id: "Pull Order", function: pullOrderAction },
    //   { id: "Reject Level", function: rejectLevelAction },
    // ],
    Awarded: [
      { id: "Unaward", function: unawardStoreAction },
      // { id: "Work Order", function: workOrderAction },
    ],
    // Filled: [
    //   { id: "Affirm", function: affirmStoreAction },
    //   // { id: "ReCoupon", function: reCouponAction },
    //   // { id: "Work More", function: workMoreAction },
    // ],
    // FilledIncomplete: [
    //   { id: "Affirm", function: affirmStoreAction },
    //   // { id: "ReCoupon", function: reCouponAction },
    //   // { id: "Work More", function: workMoreAction },
    // ],
    // ExecutedPend: [
    //   // { id: "Alert CP", function: alertCPAction },
    //   // { id: "Work Order", function: workOrderAction },
    //   {
    //     id: "Request Change",
    //     function: moveStatusBackOPStoreAction,
    //   },
    // ],
    // ExecutedPendOPChangeRequested: [
    //   { id: "Alert CP", function: alertCPAction },
    //   { id: "Work Order", function: workOrderAction },
    // ],
    // ExecutedPendRPChangeRequested: [
    //   { id: "Move to Awarded", function: moveToAwardedOPStoreAction },
    //   // { id: "Alert CP", function: alertCPAction },
    //   // { id: "Work Order", function: workOrderAction },
    // ],
    // ExecutedPendRPAgreeChange: [
    //   { id: "Move to Awarded", function: moveToAwardedOPStoreAction },
    //   // { id: "Alert CP", function: alertCPAction },
    //   // { id: "Work Order", function: workOrderAction },
    // ],
    Executed: [
      { id: "Affirm", function: affirmStoreAction },
      // { id: "ReCoupon", function: returnLegsViewerArray }, // NOTE this is handles in the context menu functions
      // { id: "Work Order", function: workOrderAction },
      {
        id: "Request Change",
        function: moveStatusBackOPStoreAction,
      },
    ],
    ExecutedOPChangeRequested: [
      { id: "Affirm", function: affirmStoreAction },
      // { id: "ReCoupon", function: reCouponAction },
      // { id: "Work Order", function: workOrderAction },
    ],
    ExecutedRPChangeRequested: [
      { id: "Move to Awarded", function: moveToAwardedOPStoreAction },
      // { id: "ReCoupon", function: reCouponAction },
      // { id: "Work Order", function: workOrderAction },
      { id: "Affirm", function: affirmStoreAction },
    ],
    ExecutedRPAgreeChange: [
      { id: "Move to Awarded", function: moveToAwardedOPStoreAction },
      // { id: "ReCoupon", function: reCouponAction },
      // { id: "Work Order", function: workOrderAction },
      { id: "Affirm", function: affirmStoreAction },
    ],
    // AffirmedPend: [
    //   { id: "Update Allocations", function: updateAllocationsAction },
    //   { id: "Check Pre-Trade", function: checkPreTradeAction },
    // ],
    // Closed: [
    //   { id: "Re-Open", function: reOpenStoreAction },
    //   // { id: "Cancel in OMS", function: cancelInOMSAction },
    // ],
    // ReCouponed: [
    //   { id: "Review ReCoupon Fees", function: reviewRecouponFeesAction },
    // ],
    // ReCouponChangeRequested: [
    //   { id: "View ReCoupon Fees", function: viewRecouponFeesAction },
    // ],
  },
  ER_RFQ: {
    Received: [
      { id: "Recall", function: recallStoreAction },
      // { id: "Update Level", function: updateLevelAction },
    ],
    Recalled: [{ id: "Re-Send", function: reSendStoreAction }],
    // ReOpened: [{ id: "Re-Send", function: reSendStoreAction }],
    ReSent: [{ id: "Recall", function: recallStoreAction }],
    NotDealt: [{ id: "Cancel in OMS", function: cancelInOMSStoreAction }], // [{ id: "Re-Send", function: reSendStoreAction }],
    Acknowledged: [{ id: "Recall", function: recallStoreAction }],
    Rejected: [{ id: "Re-Send", function: reSendStoreAction }],
    Quoted: [
      { id: "Award", function: awardStoreAction }, //Award button is filtered out if ES Status == "Awarded". See GetExecutioncontextMenuItems.tsx
      { id: "Recall", function: recallStoreAction },
      { id: "Request Requote", function: reQuoteStoreAction },
    ],
    InvalidQuote: [
      { id: "Recall", function: recallStoreAction },
      { id: "Request Requote", function: reQuoteStoreAction },
    ],
    ReQuoteRequested: [
      { id: "Recall", function: recallStoreAction },
      { id: "Award", function: awardStoreAction },
      { id: "Request Requote", function: reQuoteStoreAction },
      // { id: "Work Panel", function: workPanelAction },
    ],
    Awarded: [{ id: "Unaward", function: unawardStoreAction }],
    OffQuote: [
      { id: "Request Requote", function: reQuoteStoreAction },
      { id: "Recall", function: recallStoreAction },
    ],
    QuotedExpired: [
      { id: "Request Requote", function: reQuoteStoreAction },
      { id: "Recall", function: recallStoreAction },
    ],
    ExecutedPend: [
      // { id: "Alert CP", function: alertCPAction },
      {
        id: "Request Change",
        function: moveStatusBackOPStoreAction,
      },
    ],
    // AffirmedPend: [
    //   { id: "Update Allocations", function: updateAllocationsAction },
    // ],

    Executed: [
      { id: "Affirm", function: affirmStoreAction },
      // { id: "ReCoupon", function: reCouponAction },
      {
        id: "Request Change",
        function: moveStatusBackOPStoreAction,
      },
    ],
    ExecutedOPChangeRequested: [
      { id: "Affirm", function: affirmStoreAction },
      // { id: "ReCoupon", function: reCouponAction },
    ],
    ExecutedRPChangeRequested: [
      { id: "Move to Awarded", function: moveToAwardedOPStoreAction },
      // { id: "ReCoupon", function: reCouponAction },
      { id: "Affirm", function: affirmStoreAction },
    ],
    ExecutedRPAgreeChange: [
      { id: "Move to Awarded", function: moveToAwardedOPStoreAction },
      // { id: "ReCoupon", function: reCouponAction },
      { id: "Affirm", function: affirmStoreAction },
    ],
    // ExecutedPendOPChangeRequested: [
    //   { id: "Alert CP", function: alertCPAction },
    // ],
    ExecutedPendRPChangeRequested: [
      { id: "Move to Awarded", function: moveToAwardedOPStoreAction },
      // { id: "Alert CP", function: alertCPAction },
    ],
    ExecutedPendRPAgreeChange: [
      { id: "Move to Awarded", function: moveToAwardedOPStoreAction },
      // { id: "Alert CP", function: alertCPAction },
    ],
    // Affirmed: [{ id: "Work More", function: workMoreAction }],
    // Closed: [
    //   { id: "Re-Open", function: reOpenStoreAction },
    //   // { id: "Cancel in OMS", function: cancelInOMSAction },
    // ],
    // Complete: [{ id: "Work More", function: workMoreAction }],
  },
  Order: {
    Sent: [
      { id: "Recall", function: recallStoreAction },
      { id: "Not Dealt", function: notDealtStoreAction },
    ],
    Received: [
      { id: "Recall", function: recallStoreAction },
      { id: "Not Dealt", function: notDealtStoreAction },
      // { id: "Close Trade", function: closeStoreAction },- NO CLOSED STATUS
    ],
    Recalled: [
      { id: "Re-Send", function: reSendStoreAction },
      { id: "Not Dealt", function: notDealtStoreAction },
      // { id: "Close Trade", function: closeStoreAction },- NO CLOSED STATUS
    ],
    ReSent: [
      { id: "Recall", function: recallStoreAction },
      { id: "Not Dealt", function: notDealtStoreAction },
    ],
    NotDealt: [
      { id: "Re-Send", function: reSendStoreAction },
      { id: "Cancel in OMS", function: cancelInOMSStoreAction },
      { id: "Re-create Blocks", function: recreateBlocksStoreAction },
      // { id: "Re-Send", function: reSendStoreAction },
      // { id: "Work Order", function: actionUnderDevelopment }, // function: workOrderAction },
      // { id: "Close Trade", function: closeStoreAction }, - NO CLOSED STATUS
    ],
    Working: [
      { id: "Recall", function: recallStoreAction },
      // { id: "Pull Order", function: actionUnderDevelopment }, //  function: pullOrderAction },
      // { id: "Update Level", function: actionUnderDevelopment }, //  function: updateLevelAction },
      // { id: "Copy Trade", function: actionUnderDevelopment }, // function: copyTradeAction },
    ],
    Filled: [
      { id: "Affirm", function: affirmStoreAction },
      // { id: "Lay-Off Risk", function: actionUnderDevelopment }, //  function: layOffRiskAction },
    ],
    NoMoreFills: [
      { id: "Affirm", function: affirmStoreAction },
      // { id: "Lay-Off Risk", function: actionUnderDevelopment }, //  function: layOffRiskAction },
    ],
    Acknowledged: [
      { id: "Recall", function: recallStoreAction },
      { id: "Not Dealt", function: notDealtStoreAction },
    ],
    // ChangePending: [
    //   // No actions - OP can only view trade at this status
    // ],
    // LevelUpdated: [
    //   { id: "Update Level", function: actionUnderDevelopment }, //  function: updateLevelAction },
    //   { id: "Pull Order", function: actionUnderDevelopment }, // function: pullOrderAction },
    // ],
    // LevelUpdatedCP: [
    //   { id: "Update Level", function: actionUnderDevelopment }, //  function: updateLevelAction },
    //   { id: "Accept Level", function: acceptLevelStoreAction },
    //   { id: "Pull Order", function: actionUnderDevelopment }, // function: pullOrderAction },
    // ],
    // PartiallyFilled: [
    //   { id: "Update Level", function: actionUnderDevelopment }, // function: updateLevelAction },
    //   { id: "Pull Order", function: actionUnderDevelopment }, // function: pullOrderAction },
    //   { id: "Recall Order", function: recallStoreAction },
    //   { id: "Copy Trade", function: actionUnderDevelopment }, //  function: copyTradeAction },
    // ],
    // FilledIncomplete: [
    //   { id: "Affirm", function: affirmStoreAction },
    //   { id: "ReCoupon", function: actionUnderDevelopment }, // function: reCouponAction },
    //   { id: "Work More", function: actionUnderDevelopment }, // function: workMoreAction },
    // ],
    // LevelAccepted: [
    //   { id: "Update Level", function: actionUnderDevelopment }, // function: updateLevelAction },
    //   { id: "Pull Order", function: actionUnderDevelopment }, // function: pullOrderAction },
    //   { id: "Reject Order", function: rejectStoreAction },
    // ],
    // Affirmed: [
    //   { id: "Check Pre-Trade", function: actionUnderDevelopment }, // function: checkPreTradeAction }
    // ],
    // AffirmedPend: [
    //   { id: "Check Pre-Trade", function: actionUnderDevelopment }, //  function: checkPreTradeAction }
    // ],

    Rejected: [
      { id: "Re-Send", function: reSendStoreAction },
      { id: "Not Dealt", function: notDealtStoreAction },
      // { id: "Close Trade", function: closeStoreAction },
    ],

    // Closed: [
    //   { id: "Re-Open", function: reOpenStoreAction },
    //   { id: "Cancel in OMS", function: cancelInOMSAction },
    // ],
  },
  ER_Order: {
    Received: [{ id: "Recall", function: recallStoreAction }],
    ReSent: [{ id: "Recall", function: recallStoreAction }],
    Working: [{ id: "Recall", function: recallStoreAction }],
    Recalled: [
      { id: "Re-Send", function: reSendStoreAction },
      { id: "Not Dealt", function: notDealtStoreAction },
    ],
    Acknowledged: [
      { id: "Recall", function: recallStoreAction },
      { id: "Not Dealt", function: notDealtStoreAction },
    ],
    Filled: [{ id: "Affirm", function: affirmStoreAction }],
    NoMoreFills: [{ id: "Affirm", function: affirmStoreAction }],
  },
};

export const actionsConfigRP: any = {
  RFQ: {
    Received: [
      { id: "Quote", function: quoteTradeStoreAction },
      { id: "Acknowledge", function: acknowledgeStoreAction },
      { id: "Reject", function: rejectStoreAction },
      // { id: "Get Rates", function: getRatesAction },
      // { id: "Export Request", function: exportRequestAction },
    ],
    ReSent: [
      { id: "Quote", function: quoteTradeStoreAction },
      { id: "Acknowledge", function: acknowledgeStoreAction },
      { id: "Reject", function: rejectStoreAction },
      // { id: "Get Rates", function: getRatesAction },
      // { id: "Export Request", function: exportRequestAction },
    ],
    Acknowledged: [
      { id: "Quote", function: quoteTradeStoreAction },
      { id: "Reject", function: rejectStoreAction },
      // { id: "Get Rates", function: getRatesAction },
      // { id: "Lay-Off Risk", function: layOffRiskAction },
      // { id: "Export Request", function: exportRequestAction },
    ],
    Quoted: [
      { id: "Re-Quote", function: quoteTradeStoreAction },
      { id: "Off-Quote", function: offQuoteStoreAction },
      // { id: "Get Rates", function: getRatesAction },
      // { id: "Lay-Off Risk", function: layOffRiskAction },
    ],
    // InvalidQuote: [
    //   { id: "Re-Quote", function: quoteTradeStoreAction },
    //   // { id: "Get Rates", function: getRatesAction },
    // ],
    ReQuoteRequested: [
      { id: "Re-Quote", function: quoteTradeStoreAction },
      { id: "Off-Quote", function: offQuoteStoreAction },
      // { id: "Get Rates", function: getRatesAction },
      // { id: "Export Request", function: exportRequestAction },
    ],
    Rejected: [
      { id: "Quote", function: quoteTradeStoreAction },
      // { id: "Get Rates", function: getRatesAction },
      // { id: "Export Request", function: exportRequestAction },
    ],
    Awarded: [
      { id: "Execute", function: executeTradeStoreAction },
      // { id: "More Appetite", function: moreAppetiteAction },
      { id: "Off-Quote", function: offQuoteStoreAction },
      // { id: "Lay-Off Risk", function: layOffRiskAction },
    ],
    Executed: [
      // { id: "More Appetite", function: moreAppetiteAction },
      // { id: "Update Execution", function: updateExecutionAction },
      {
        id: "Request Change",
        function: moveStatusBackRPStoreAction,
      },
    ],
    ExecutedOPChangeRequested: [
      {
        id: "Accept Change",
        function: agreeMoveToAwardedRPStoreAction,
      },
      // { id: "More Appetite", function: moreAppetiteAction },
      // { id: "Update Execution", function: updateExecutionAction },
    ],

    ExecutedRPChangeRequested: [
      { id: "Pull Request", function: pullRequestStoreAction },
      // { id: "More Appetite", function: moreAppetiteAction },
      // { id: "Update Execution", function: updateExecutionAction },
    ],

    ExecutedRPAgreeChange: [
      // { id: "More Appetite", function: moreAppetiteAction },
      // { id: "Update Execution", function: updateExecutionAction },
    ],

    // ExecutedPend: [
    //   // { id: "Update Execution", function: updateExecutionAction },
    //   // { id: "More Appetite", function: moreAppetiteAction },
    //   // { id: "Lay-Off Risk", function: layOffRiskAction },
    //   {
    //     id: "Request Change",
    //     function: moveStatusBackRPStoreAction,
    //   },
    // ],
    // ExecutedPendOPChangeRequested: [
    //   // { id: "Update Execution", function: updateExecutionAction },
    //   // { id: "More Appetite", function: moreAppetiteAction },
    //   {
    //     id: "Accept Change",
    //     function: agreeMoveToAwardedRPStoreAction,
    //   },
    // ],
    // ExecutedPendRPChangeRequested: [
    //   // { id: "Update Execution", function: updateExecutionAction },
    //   // { id: "More Appetite", function: moreAppetiteAction },
    //   {
    //     id: "Pull Request",
    //     function: pullRequestStoreAction,
    //   },
    // ],
    // ExecutedPendRPAgreeChange: [
    //   // { id: "Update Execution", function: updateExecutionAction },
    //   // { id: "More Appetite", function: moreAppetiteAction },
    //   {
    //     id: "Pull Request",
    //     function: pullRequestStoreAction,
    //   },
    // ],
    OffQuote: [
      { id: "Re-Quote", function: quoteTradeStoreAction },
      { id: "Reject", function: rejectStoreAction },
      // { id: "Get Rates", function: getRatesAction },
      // { id: "Export Request", function: exportRequestAction },
    ],
    // QuotedExpired: [
    //   { id: "Re-Quote", function: quoteTradeStoreAction },
    //   { id: "Reject", function: rejectStoreAction },
    //   // { id: "Get Rates", function: getRatesAction },
    //   // { id: "Export Request", function: exportRequestAction },
    // ],
  },
  Order: {
    Received: [
      { id: "Acknowledge", function: acknowledgeStoreAction },
      { id: "Working", function: workingStoreAction },
      { id: "Reject", function: rejectStoreAction },
    ],
    ReSent: [
      { id: "Acknowledge", function: acknowledgeStoreAction },
      { id: "Working", function: workingStoreAction },
      { id: "Reject", function: rejectStoreAction },
    ],
    Acknowledged: [
      { id: "Working", function: workingStoreAction },
      { id: "Reject", function: rejectStoreAction },
    ],
    Working: [
      { id: "Send Fill", function: updateFillsStoreAction },
      // { id: "Fully Filled", function: actionUnderDevelopment }, // function: fullyFilledAction },
      //  { id: "Add Fill", function: actionUnderDevelopment }, // function: addFillAction },
      // { id: "Recall Fill", function: actionUnderDevelopment }, // function: recallFillAction },
      // { id: "Update Level", function: actionUnderDevelopment }, // function: updateLevelAction },
      { id: "No More Fills", function: noMoreFillsStoreAction },
      { id: "Reject", function: rejectStoreAction },
      // { id: "Lay-Off Risk", function: actionUnderDevelopment }, // function: layOffRiskAction },
    ],
    // PartiallyFilled: [
    //   { id: "No More Fills", function: actionUnderDevelopment }, // function: noMoreFillsAction },
    //   { id: "Update Fill", function: actionUnderDevelopment }, // function: updateFillAction },
    //   //  { id: "Add Fill", function: actionUnderDevelopment }, // function: addFillAction },
    //   // { id: "Fully Filled", function: actionUnderDevelopment }, // function: fullyFilledAction },
    //   { id: "Update Level", function: actionUnderDevelopment }, // function: updateLevelAction },
    //   { id: "Reject", function: rejectStoreAction },
    //   // { id: "Lay-Off Risk", function: actionUnderDevelopment }, // function: layOffRiskAction },
    // ],
    // LevelUpdated: [
    //   { id: "No More Fills", function: actionUnderDevelopment }, // function: noMoreFillsAction },
    //   //  { id: "Add Fill", function: actionUnderDevelopment }, // function: addFillAction },
    //   // { id: "Fully Filled", function: actionUnderDevelopment }, // function: fullyFilledAction },
    //   { id: "Update Level", function: actionUnderDevelopment }, // function: updateLevelAction },
    //   { id: "Reject", function: rejectStoreAction },
    // ],
    // InvalidQuote: [
    //   { id: "Update Level", function: actionUnderDevelopment }, // function: updateLevelAction }
    // ],
    // LevelUpdatedCP: [
    //   { id: "Working", function: workingStoreAction },
    //   // { id: "Fully Filled", function: actionUnderDevelopment }, // function: fullyFilledAction },
    //   //  { id: "Add Fill", function: actionUnderDevelopment }, // function: addFillAction },
    //   { id: "Update Level", function: actionUnderDevelopment }, // function: updateLevelAction },
    //   { id: "No More Fills", function: actionUnderDevelopment }, // function: noMoreFillsAction },
    //   { id: "Reject", function: rejectStoreAction },
    // ],
    // LevelAccepted: [
    //   // { id: "Fully Filled", function: actionUnderDevelopment }, // function: fullyFilledAction },
    //   //  { id: "Add Fill", function: actionUnderDevelopment }, // function: addFillAction },
    //   { id: "Update Level", function: actionUnderDevelopment }, // function: updateLevelAction },
    //   { id: "No More Fills", function: actionUnderDevelopment }, // function: noMoreFillsAction },
    //   { id: "Reject", function: rejectStoreAction },
    //   // { id: "Lay-Off Risk", function: actionUnderDevelopment }, // function: layOffRiskAction },
    // ],
    Filled: [{ id: "Edit Fills", function: editFilledStoreAction }],
    NoMoreFills: [{ id: "Edit Fills", function: editFilledStoreAction }],
    ChangePending: [{ id: "Send Fill", function: updateFillsStoreAction }],
    // LQC-3249 - close out the fills; more fills need the OP to extend expiry.
    Expired: [{ id: "No More Fills", function: noMoreFillsStoreAction }],
    // FilledIncomplete: [
    //   { id: "Update Fill", function: actionUnderDevelopment }, //  function: updateFillAction },
    //   { id: "Recall Fill", function: actionUnderDevelopment }, //  function: recallFillAction },
    //   // { id: "Lay-Off Risk", function: actionUnderDevelopment }, //  function: layOffRiskAction },
    // ],
    Rejected: [
      { id: "Acknowledged", function: acknowledgeStoreAction },

      // { id: "Working", function: workingStoreAction }, //  function: workingAction },
      // { id: "Fully Filled", function: actionUnderDevelopment }, //  function: fullyFilledAction },
      //  { id: "Add Fill", function: actionUnderDevelopment }, //  function: addFillAction },
    ],
    // RecouponRequest: [
    //   { id: "Add ReCoupon Fees", function: addRecouponFeesAction },
    //   { id: "Reject ReCoupon", function: rejectRecouponAction },
    // ],
    // Recouponed: [
    //   { id: "Change Fees", function: changeFeesAction },
    //   { id: "Lay-Off Risk", function: layOffRiskAction },
    //   { id: "More Appetite", function: moreAppetiteAction },
    // ],
    // RecouponedChangeRequested: [
    //   { id: "Change ReCouponFees", function: changeReCouponFees },
    //   { id: "Reject ReCoupon", function: rejectRecouponAction },
    // ],
  },
};
